const tokenKey = 'ContinuationToken';

export const getNextPageToken = (
  nextPageUrl: string | null | undefined = null,
  key = tokenKey,
) => {
  if (!nextPageUrl) return undefined;

  const [, urlParams] = nextPageUrl.split('?');
  const queryParams = new URLSearchParams(urlParams);

  return queryParams.get(key) || undefined;
};
